import { Box, PaletteColor, SxProps, Theme, Typography, useTheme } from '@mui/material';


export const Pill = (props: { text: string, pallet?: PaletteColor, sx?: SxProps<Theme> }) => {
  const theme = useTheme();
  const colorToUse = props.pallet ?? theme.palette.success;
  return <Box
    sx={{
      ml: 4,
      display: 'inline-flex',
      p: '2px 8px',
      alignItems: 'center',
      borderRadius: '16px',
      border: '1px solid',
      borderColor: colorToUse[200],
      background: colorToUse[50],
      ...props.sx,
    }}
  >
    <Typography variant="textXS"
      sx={{ color: colorToUse[700] }}>
      {props.text}
    </Typography>
  </Box>;

};
